"use client";

import errorWarningAnimation from "@/public/lottie-animations/error-warning.json";
import { motion } from "framer-motion";
import Lottie from "lottie-react";
import { useTranslations } from "@frontend/lib/next-intl-typed";
import {
  useInsuranceConnectorContext,
  useInsuranceConnectorSend,
} from "../insurance-connector-provider";

export function EligibilityStateRejection() {
  const t = useTranslations("InsuranceConnector");
  const context = useInsuranceConnectorContext();
  const send = useInsuranceConnectorSend();

  return (
    <div className="flex flex-col justify-between h-full pt-2 md:pt-[48px]">
      <div className="space-y-4 md:space-y-6">
        <div className="w-20 h-20">
          <Lottie animationData={errorWarningAnimation} loop={false} />
        </div>
        <h2 className="text-[32px] md:text-[48px] leading-[110%] md:leading-[120%] tracking-[-0.02em] font-semibold">
          {t("NoTreatmentsInState", {
            orgName: context.orgName,
            consumerState: context.consumerState,
          })}
        </h2>
        <p className="text-[18px] md:text-[24px] leading-[120%] tracking-[-0.02em] font-normal">
          {t("AreaRestrictions")}
        </p>
      </div>

      <div className="flex justify-end mt-6">
        <motion.button
          type="button"
          onClick={() => send({ type: "DISMISS" })}
          className="rounded-full font-medium text-white px-[53px] md:px-[48px] py-5 md:py-[20px] text-base md:text-xl md:w-auto"
          initial={{ backgroundColor: "#000000" }}
          whileHover={{ backgroundColor: "#00A3FF" }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          {t("Dismiss")}
        </motion.button>
      </div>
    </div>
  );
}
